module.exports = __webpack_public_path__ + "static/media/BadgeTemplates-63.e8cd6ee6.svg";